module.exports = (__webpack_require__(24))(6);


//////////////////
// WEBPACK FOOTER
// delegated ./app/assets/javascripts/slickgrid.js from dll-reference slickgrid_lib
// module id = 22
// module chunks = 6 12 17